import React, { useState, useImperativeHandle } from "react";
import ResponsiveWrapper from "../_responsive-wrapper";
import Icon from "../Icon/icon";
import lockBodyScroll from "@helpers/lockBodyScroll";

const ActionSheetTabs = React.forwardRef(({ children }, ref) => {
    const [activePanel, setActivePanel] = useState(null);

    const togglePanel = (panel) => {
        setActivePanel(activePanel === panel ? null : panel);
    };

    useImperativeHandle(ref, () => ({ closePanel: () => setActivePanel(null) }));

    lockBodyScroll(activePanel !== null);

    return (
        <ResponsiveWrapper className="action-sheet-tabs">
            <div className={`action-sheet-tabs__overlay ${activePanel !== null ? "action-sheet-tabs__overlay--active" : ""}`} onClick={() => togglePanel(null)} />
            <div className={`action-sheet-tabs__content ${activePanel !== null ? "action-sheet-tabs__content--active" : ""}`}>
                {React.Children.map(children, (child, index) => (
                    <div key={index} className={`action-sheet-tabs__content-panel ${activePanel === index ? "action-sheet-tabs__content-panel--open" : ""}`}>
                        <div className="action-sheet-tabs__panel-header">
                            <span>
                                <Icon icon={child.props.icon} />
                                {child.props.title}
                            </span>
                            <button
                                type="button"
                                className="action-sheet-tabs__filter-close"
                                onClick={() => togglePanel(null)}
                            >
                                <Icon icon="x" />
                            </button>
                        </div>
                        <div className="action-sheet-tabs__panel-body">
                            {child.props.children}
                        </div>
                    </div>
                ))}
                <div className="action-sheet-tabs__filter">
                    {React.Children.map(children, (child, index) => (
                        <div key={index} className="action-sheet-tabs__filter-item">
                            <button
                                type="button"
                                onClick={() => togglePanel(index)}
                                className={`action-sheet-tabs__filter-button ${activePanel === index ? "action-sheet-tabs__filter-button--active" : ""}`}
                            >
                                <Icon icon={child.props.icon} />
                                {child.props.title}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </ResponsiveWrapper>
    );
});

export default ActionSheetTabs;
